export default "__VITE_ASSET__B7$BVf5$__"